import React from 'react';
import './AjeetMiniTecSpec.css';

const AjeetMiniTecSpec = () => {
  return (
    <div className="zuppa_ajeet_minitecspec_wrapper py-5">
      <div className="container">
        <h2 className="zuppa_ajeet_minitecspec_heading text-center mb-5">
          Technical Specifications
        </h2>

        <div className="row zuppa_ajeet_minitecspec_row">
          {/* Left Column */}
          <div className="col-lg-6 col-md-12 d-flex">
            <div className="zuppa_ajeet_minitecspec_box w-100 text-start">
              <ul className="zuppa_ajeet_minitecspec_list">
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  UAV Weight with Battery: Maximum of 1.172 Kgs 

                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Endurance (Ideal Wind & MSL Conditions): 15 Minutes
                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Range: 0.5 Km
                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Maximum Speed: 20 m/s 
                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Maximum Operating Altitude:   120 in ft

                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Software Compatibility: Zuppa Ground Control Station (GCS) 3.3.4
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-6 col-md-12 d-flex">
            <div className="zuppa_ajeet_minitecspec_box w-100 text-start">
              <ul className="zuppa_ajeet_minitecspec_list">
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Battery: 2600 mAh
                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Wind Resistance: 30 Km/hr
                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Auto pilot: NavGati™ - PCB & Firmware (Proprietary)
                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Frequency Band :2.402-2.48 GHz
                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Sensors: Ground Facing LIDAR, Barometer, Magnetic Compass, Accelerometer
                </li>
                <li className="zuppa_ajeet_minitecspec_item">
                  <span className="zuppa_ajeet_minitecspec_bullet">🔹</span>
                  Flight Modes: Waypoint Navigation, Manual control, Hover, Return-to-Home, Position Hold
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AjeetMiniTecSpec;
